import type { NextPage } from 'next';
import styles from './text-field1.module.scss';
import { TextField1Type } from '@/types/itemsFormBlock.types';
import React from 'react';

const TextField: NextPage<TextField1Type> = ({
  className = '',
  label,
  placeholder,
  value,
  onChange,
  error,
}) => {
  return (
    <div className={[styles.textField, className].join(' ')}>
      <div className={styles.label}>{label}</div>
      <div className={styles.row}>
        <input
          className={`${styles.enterYourEmail} ${error ? styles.error : ''}`}
          placeholder={placeholder}
          type="text"
          value={value}
          onChange={onChange}
        />
      </div>
      {error && <div className={styles.errorText}>{error}</div>}
    </div>
  );
};

export default TextField;
